import {PaymentRequestShippingAddress} from '@stripe/stripe-js';

import {makeFormAddressData} from 'desktop/pages/cart/utils/makeFormAddressData';

import {ApplePayPaymentInfoType} from 'types/applePayType';

import {replaceLostShippingFields} from './replaceLostShippingFields';

/**
 * checks and replaces shipping names if necessary
 * */
const getShippingNames = (
    shippingAddress: PaymentRequestShippingAddress & {regionId?: string | undefined},
    payerNameArray?: string[] | null,
) => {
    const recipientNameArray = shippingAddress?.recipient?.match(/\w+/g);
    const payerLastName = payerNameArray?.filter((_, i) => i !== 0).join(' ');

    if (recipientNameArray && recipientNameArray.length) {
        if (recipientNameArray?.length >= 2) {
            return [recipientNameArray[0], recipientNameArray.filter((_, i) => i !== 0).join(' ')];
        } else if (payerNameArray?.some(el => el === recipientNameArray[0])) {
            return [payerNameArray[0], payerLastName || 'LastNameEmpty'];
        } else if (recipientNameArray?.length) {
            return [recipientNameArray[0], 'LastNameEmpty'];
        }
    }
    return ['FirstNameEmpty', 'LastNameEmpty'];
};

/**
 * combines addresses from Apple Pay
 */
export function checkAndCombineData(addressData: ApplePayPaymentInfoType) {
    const {billingAddress, email, name, phone, shippingAddress} = addressData;

    const billingStreet = [billingAddress?.line1, billingAddress?.line2].filter(Boolean).join(', ');
    const shippingStreet = shippingAddress?.addressLine?.join(', ');
    const payerNameArray = name?.match(/\w+/g);

    const payerLastName = payerNameArray?.filter((_, i) => i !== 0).join(' ');

    const [shippingFirstName, shippingLastName] = getShippingNames(shippingAddress, payerNameArray);

    const shippingLostValues = replaceLostShippingFields(addressData, {
        payerLastName,
        payerNameArray,
        shippingFirstName,
        shippingLastName,
        shippingStreet,
    });

    return {
        billing: {
            city: billingAddress?.city?.trim() || 'cityEmpty',
            country: billingAddress?.country || 'countryEmpty',
            email,
            firstName: payerNameArray?.[0] || 'FirstNameEmpty',
            lastName: payerLastName || 'LastNameEmpty',
            phone,
            postcode: billingAddress?.postal_code || 'postCodeEmpty',
            region: billingAddress?.state?.trim() || 'regionEmpty',
            regionId: billingAddress?.regionId,
            street: billingStreet?.trim() || 'addressLineEmpty',
        },
        shipping: {
            city: shippingAddress?.city,
            country: shippingAddress?.country,
            email,
            firstName: shippingFirstName,
            lastName: shippingLastName,
            phone: shippingAddress?.phone,
            postcode: shippingAddress?.postalCode,
            region: shippingAddress?.region,
            regionId: shippingAddress?.regionId,
            street: shippingStreet?.trim(),
            ...shippingLostValues,
        },
    };
}

/**
 * format shipping address to form Data and check fields
 */
export function formatAndCheckAddress(addressData: ApplePayPaymentInfoType) {
    const formattedAddresses = checkAndCombineData(addressData);
    return makeFormAddressData(formattedAddresses);
}
